<template>
  <div class="qf-group" :class="{ 'show': show }">
    <div class="qf-header" @click="toggle">
      <div class="qf-icon">
        <i class="far fa-fw" :class="data.icon"></i>
      </div>
      <div class="qf-title">{{ data.title }}</div>
      <div class="qf-toggle">
        <span v-show="show">
          <i class="far fa-fw fa-minus"></i>
        </span>
        <span v-show="!show">
          <i class="far fa-fw fa-plus"></i>
        </span>
      </div>
    </div>

    <perfect-scrollbar class="qf-content">
      <router-link
        v-for="(item, index) in data.options"
        :key="index"
        :to="item.link"
        class="qf-item">
        {{ item.title }}
      </router-link>
    </perfect-scrollbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },

  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },

    preshow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.show = this.preshow;
    },

    toggle() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="scss" scoped>
  .qf-group {
    @include media ("<=tablet") {
      margin: 0 -1.5rem;
    }
  }
  .qf-header {
    display: flex;
    padding: 0.75rem 0;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba($white, 0.1);
    text-transform: uppercase;
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba($white, 0.8);
    cursor: pointer;
    transition: color 0.3s ease;

    .light & {
      color: rgba($base-color, 0.7);
      border-top-color: $grey-fade;
    }

    @include media ("<=tablet") {
      padding: 0.75rem;
    }

    &:hover {
      color: rgba($white, 1);

      .light & {
        color: rgba($base-color, 1);
      }

      .qf-toggle {
        color: $color-primary;
      }
    }
  }

  .qf-icon {
    display: inline-block;
    margin-right: 0.5rem;
    height: 1.25rem;
    width: 1.25rem;
    color: #666;
  }

  .qf-title {
    width: 85%;
  }

  .qf-toggle {
    width: 1.5rem;
    font-size: 1.125rem;
    font-weight: 700;
    text-align: center;
  }

  .qf-content {
    display: flex;
    width: 100%;
    max-height: 0;
    padding-right: 2rem;
    overflow-y: hidden;
    overflow-x: auto;
    opacity: 0;
    transition: all 0.3s ease;

    @include media ("<=tablet") {
      padding: 0 5rem 0 0.75rem;
    }

    .show & {
      max-height: 10rem;
      opacity: 1;
    }
  }

  .qf-item {
    min-width: 7.5rem;
    padding: 2rem 1rem 0.75rem;
    margin: 0 0.5rem 1rem 0;
    border: 1px solid rgba($white, 0.3);
    border-radius: 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: $white;

    .light & {
      border-color: rgba($base-color, 0.2);
      color: $base-color;
    }
  }
</style>
